import { defineComponent, inject, computed, onUnmounted } from 'vue'
import { Popover } from 'vant'
import styles from './styles.module.scss'
import { useComponentStore } from '../../../nsh5/localStores/component'
import { copyValue } from '@/utils/copy'
/**
 * 电话
 */
export default defineComponent({
  name: 'phone-call-render-view',
  components: {
    [Popover.name]: Popover,
  },

  setup: () => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const componentStore = useComponentStore()
    const client = inject<string>('client', '')
    const needRenderComponent = computed(() => client !== 'mobile')
    const telPhoneCall = componentsConfig?.hotline?.properties?.number || '400-999-6699'

    const handleClose = () => {
      componentStore.$patch({
        showPhonePopover: false,
      })
    }

    onUnmounted(() => {
      componentStore.$patch({
        showPhonePopover: false,
      })
    })

    const handleCopy = () => {
      copyValue(telPhoneCall, '电话复制成功')
    }

    const iconPx = () => {
      const $px = client === 'mobile' ? '20px' : '24px'
      return $px
    }

    return () => {
      return (
        <div class={styles.phoneCall}>
          {needRenderComponent.value ? (
            <Popover
              v-model:show={componentStore.showPhonePopover}
              class={styles.PopoverPhoneCall}
              placement="left-end"
            >
              {{
                default: () => (
                  <>
                    {
                      <div class={styles.phoneContainer}>
                        <div class={styles.header}>
                          <span>{componentsConfig?.hotline?.name}</span>
                          <ns-icon
                            name={(process.config as any).icon.close_big_outline}
                            size={iconPx()}
                            onClick={handleClose}
                          />
                        </div>
                        <div class={styles.content}>
                          <span>{telPhoneCall}</span>
                          <ns-icon
                            name={(process.config as any).icon.icon_copy}
                            size="20"
                            color="#050B27"
                            onClick={handleCopy}
                          />
                        </div>
                      </div>
                    }
                  </>
                ),
                reference: () => (
                  <div class={['icon', 'square']}>
                    <ns-icon name={(process.config as any).icon.phone} size={iconPx()} />
                  </div>
                ),
              }}
            </Popover>
          ) : (
            <a href={`tel:${telPhoneCall}`}>
              <div class={['icon', 'square', styles.mobilePhoneCall]}>
                <ns-icon name={(process.config as any).icon.phone} size={iconPx()} />
              </div>
            </a>
          )}
        </div>
      )
    }
  },
})
